import React from 'react';
import PropTypes from 'prop-types';

const sizes = {
  small: ['12px', '12px'],
  middle: ['24px', '24px'],
  large: ['48px', '48px'],
};

const AddWorklogIcon = (props) => {
  const size = typeof props.size === 'string' ? sizes[props.size] : props.size;
  const [width, height] = size;

  const svgProps = {
    width,
    height,
    style: Object.assign(
      props.shouldPadding ? { padding: '4px' } : {},
      props.style
    ),
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      {...svgProps}
    >
      <path d="M16 4C9.385 4 4 9.385 4 16s5.385 12 12 12c.357 0 .71-.018 1.059-.049C18.44 30.362 21.036 32 24 32c4.4 0 8-3.6 8-8 0-2.964-1.638-5.56-4.049-6.941.03-.35.049-.702.049-1.059 0-6.615-5.385-12-12-12zm0 2c5.535 0 10 4.465 10 10 0 .088-.01.174-.012.262A7.925 7.925 0 0 0 24 16c-4.4 0-8 3.6-8 8 0 .687.097 1.351.262 1.988-.088.003-.174.012-.262.012-5.535 0-10-4.465-10-10a9.966 9.966 0 0 1 3.982-7.98l.752.533L16 12.28V6zm-6.422 4.184-1.156 1.632 7.303 5.174 5.619-2.05-.688-1.88-4.63 1.692-6.448-4.568zM24 18c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6 2.7-6 6-6zm-1 2v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2z" />
    </svg>
  );
};
AddWorklogIcon.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.oneOf(['small', 'middle', 'large']),
    PropTypes.array,
  ]),
  shouldPadding: PropTypes.bool,
  style: PropTypes.object,
};
AddWorklogIcon.defaultProps = {
  size: 'middle',
  shouldPadding: false,
  style: {},
};

export default AddWorklogIcon;
